import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";

const tooltipText =
  'A token is a unit of text used in AI models. In English, a token can be as short as one character or as long as one word (e.g., "a" or "apple"). The total number of tokens affects both the cost and the ability to generate or process text. In English, a token can often correspond to a word, but it can also represent a single character or part of a word. For example, the word "apple" is one token, but "haven\'t" would be split into two tokens: "have" and "n\'t." While it might be common for many words to be represented as single tokens, it\'s not a strict one-token-per-word mapping.';
const maxTokensPerConversation =
  process.env.SHAKAPACKER_PUBLIC_MAX_TOKENS_PER_CONVERSATION;

const TokensUsage = ({ state }) => {
  const {
    tokensCount,
    isTokenEstimateApproximate,
    totalTokensUsed,
    subscriptionLimit,
    conversationLimitExceeded,
    subscriptionLimitExceeded,
    status,
  } = state;

  const isGenerating = status === "GENERATING";
  const isFinished = status === "FINISHED";
  const approxPrefix = isTokenEstimateApproximate ? "~" : "";
  const formattedTokensCount = `${approxPrefix}${numeral(tokensCount).format("0.[0]a")}`;
  const formattedMaxTokens = numeral(maxTokensPerConversation).format("0.[0]a");
  const formattedTotalTokensUsed = numeral(totalTokensUsed).format("0.[0]a");
  const formattedLimit =
    subscriptionLimit !== null
      ? numeral(subscriptionLimit).format("0.[0]a")
      : "unlimited";

  const conversationAtLimit =
    conversationLimitExceeded ||
    tokensCount >= Number(maxTokensPerConversation);
  const conversationColorClass = conversationAtLimit
    ? "text-danger"
    : "text-gray";
  const planColorClass = subscriptionLimitExceeded
    ? "text-danger"
    : "text-gray";

  return (
    <small className="text-gray">
      <span className={conversationColorClass}>
        Tokens in this conversation:{" "}
        {isGenerating ? (
          <FontAwesomeIcon icon="far fa-spinner" pulse />
        ) : (
          formattedTokensCount
        )}{" "}
        / {formattedMaxTokens}
      </span>
      <Tooltipable
        trigger="click"
        placement="right"
        className="ml-1"
        text={tooltipText}
      >
        <FontAwesomeIcon icon="far fa-info-circle" />
      </Tooltipable>
      <br />
      <span className={planColorClass}>
        Total tokens used (plan limit): {formattedTotalTokensUsed} of{" "}
        {formattedLimit}
      </span>
      {isFinished && conversationLimitExceeded && (
        <>
          <br />
          <span className="text-danger">
            <FontAwesomeIcon
              icon="far fa-exclamation-triangle"
              className="mr-1"
            />
            Conversation token limit reached. Start a new prompt.
          </span>
        </>
      )}
      {isFinished &&
        !conversationLimitExceeded &&
        subscriptionLimitExceeded && (
          <>
            <br />
            <span className="text-danger">
              <FontAwesomeIcon
                icon="far fa-exclamation-triangle"
                className="mr-1"
              />
              Plan token limit reached.{" "}
              <a
                href="/billing"
                target="_blank"
                rel="noopener noreferrer"
                className="text-success"
              >
                Upgrade your plan
              </a>
            </span>
          </>
        )}
    </small>
  );
};

export default TokensUsage;
